export const isPasswordValid = (password = '') => (/((?=.*[0-9])(?=.*[a-z])(?=.*[A-Z]).{6,20})/).test(password);

export const isPasswordsEquals = (password, confPassword) => password != null && password === confPassword;

export const isEmail = (email = '') => (/^[a-zA-Z0-9.+_-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/).test(email);

export const TEST_EMAIL_REGEX =
  /test\+\b[0-9a-f]{8}\b-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-\b[0-9a-f]{12}\b@apester.com/;

export const EMAIL_ERROR = 'Invalid Email.';
export const EMAIL_MISSING = 'You need to enter your email.';

export const PASSWORD_INFO = '(1 Uppercase, 1 lowercase, a number and 6+ characters)';
export const CONFIRM_ERROR = 'Passwords do not match.';

// Invite-only signup gate. On a rejected Google signup the users service redirects
// back with ?error=<code>; on local signup it returns 403 with this same message.
export const CONTACT_EMAIL = 'contactus@apester.com';
export const SIGNUP_REJECTED_ERRORS = ['signup_invite_only', 'signup_rejected'];
export const INVITE_ONLY_MESSAGE = 'Registration is by invitation only. To get started with Apester, '
  + `please contact us at ${CONTACT_EMAIL} and we'll be glad to help you.`;
